module.exports = __webpack_public_path__ + "img/advanced-card.2bb9d996.png";